/* ============================================================
   Beauty Plus — theme.js
   Interactions: reveal-on-scroll, accordions, brush dial,
   product gallery, quantity stepper, share menu, mobile nav,
   and an AJAX cart drawer wired to Shopify's /cart endpoints.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.rv:not(.in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- accordions ---------- */
  function initAccordions() {
    document.querySelectorAll('[data-acc-h]').forEach(function (h) {
      h.addEventListener('click', function () {
        var item = h.closest('.acc__item');
        var body = item.querySelector('.acc__body');
        var open = item.classList.toggle('open');
        body.style.maxHeight = open ? body.scrollHeight + 'px' : 0;
      });
    });
    document.querySelectorAll('.acc__item.open .acc__body').forEach(function (b) {
      b.style.maxHeight = b.scrollHeight + 'px';
    });
  }

  /* ---------- product gallery ---------- */
  function initGalleries() {
    document.querySelectorAll('[data-gallery]').forEach(function (g) {
      var main = g.querySelector('[data-gallery-main]');
      var thumbs = Array.from(g.querySelectorAll('[data-gallery-thumb]'));
      if (!main || !thumbs.length) return;

      var current = 0;
      var autoTimer = null;
      var resumeTimer = null;
      var AUTO_MS = 1500;
      var RESUME_MS = 4000;

      function goTo(idx) {
        var btn = thumbs[idx];
        var img = main.querySelector('img');
        if (!img) return;
        thumbs.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        img.classList.add('fading');
        setTimeout(function () {
          img.src = btn.getAttribute('data-src');
          main.classList.toggle('contain', btn.classList.contains('contain'));
          img.classList.remove('fading');
        }, 280);
        current = idx;
      }

      function startAuto() {
        if (thumbs.length < 2) return;
        autoTimer = setInterval(function () {
          goTo((current + 1) % thumbs.length);
        }, AUTO_MS);
      }

      function stopAuto() {
        clearInterval(autoTimer);
        autoTimer = null;
      }

      function pauseAndResume() {
        stopAuto();
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(startAuto, RESUME_MS);
      }

      thumbs.forEach(function (btn, idx) {
        if (btn.classList.contains('active')) current = idx;
        btn.addEventListener('click', function () {
          goTo(idx);
          pauseAndResume();
        });
      });

      // Preload + decode all full-res images so first auto-transition is seamless
      var srcs = thumbs.map(function(b) { return b.getAttribute('data-src'); }).filter(Boolean);
      if (!srcs.length) { startAuto(); return; }
      var remaining = srcs.length;
      function onReady() { if (--remaining === 0) startAuto(); }
      srcs.forEach(function(src) {
        var pi = new Image();
        pi.src = src;
        if (pi.decode) { pi.decode().then(onReady).catch(onReady); }
        else { pi.onload = pi.onerror = onReady; }
      });
    });
  }

  /* ---------- quantity stepper ---------- */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('[data-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var d = parseInt(btn.getAttribute('data-step'), 10);
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + d);
        });
      });
    });
  }

  /* ---------- share menu ---------- */
  function initShare() {
    document.querySelectorAll('[data-share-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var menu = btn.parentElement.querySelector('.share-menu');
        document.querySelectorAll('.share-menu').forEach(function (m) { if (m !== menu) m.classList.remove('open'); });
        menu.classList.toggle('open');
      });
    });
    document.addEventListener('click', function () {
      document.querySelectorAll('.share-menu').forEach(function (m) { m.classList.remove('open'); });
    });
    document.querySelectorAll('[data-share]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var type = btn.getAttribute('data-share');
        var url = window.location.href;
        if (type === 'native' && navigator.share) { navigator.share({ url: url }); }
        else if (type === 'copy') { navigator.clipboard && navigator.clipboard.writeText(url); toast('Link copied'); }
        else if (type === 'wa') { window.open('https://wa.me/?text=' + encodeURIComponent(url), '_blank'); }
        else if (type === 'fb') { window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url), '_blank'); }
      });
    });
  }

  /* ---------- mobile nav ---------- */
  function initMobileNav() {
    var sheet = document.getElementById('msheet');
    if (!sheet) return;
    var open = document.querySelector('[data-burger]');
    var close = sheet.querySelector('[data-msheet-close]');
    open && open.addEventListener('click', function () { sheet.classList.add('open'); });
    close && close.addEventListener('click', function () { sheet.classList.remove('open'); });
    sheet.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { sheet.classList.remove('open'); });
    });
  }

  /* ---------- brush dial ---------- */
  function arcPath(deg) {
    var cx = 100, cy = 100, r = 92, start = -90, end = -90 + (deg / 30) * 120;
    var a0 = start * Math.PI / 180, a1 = end * Math.PI / 180;
    var x0 = cx + r * Math.cos(a0), y0 = cy + r * Math.sin(a0);
    var x1 = cx + r * Math.cos(a1), y1 = cy + r * Math.sin(a1);
    return 'M ' + x0 + ' ' + y0 + ' A ' + r + ' ' + r + ' 0 0 1 ' + x1 + ' ' + y1;
  }
  function initDial() {
    document.querySelectorAll('[data-dial]').forEach(function (dial) {
      var opts = dial.querySelector('[data-dial-opts]');
      if (!opts) return;
      var wandWrap = dial.querySelector('[data-dial-wand]');
      var wandImg = wandWrap.querySelector('img');
      var degEl = dial.querySelector('[data-dial-deg]');
      var uEl = dial.querySelector('[data-dial-unit]');
      var arc = dial.querySelector('[data-dial-arc]');
      var list = Array.prototype.slice.call(opts.querySelectorAll('.dial__opt'));
      function select(btn) {
        list.forEach(function (b) { b.setAttribute('aria-selected', 'false'); });
        btn.setAttribute('aria-selected', 'true');
        var deg = +btn.getAttribute('data-deg');
        wandImg.style.opacity = 0;
        var src = btn.getAttribute('data-wand');
        setTimeout(function () { if (src) wandImg.src = src; wandImg.style.opacity = 1; }, 220);
        wandWrap.style.transform = 'translate(-50%,-50%) rotate(' + deg + 'deg)';
        if (degEl) degEl.textContent = deg + '°';
        if (uEl) uEl.textContent = btn.getAttribute('data-name') || '';
        if (arc) arc.setAttribute('d', arcPath(deg));
      }
      list.forEach(function (b) { b.addEventListener('click', function () { select(b); }); });
      // Preload all wand images so first auto-rotation transition is seamless
      list.forEach(function(btn) { var s = btn.getAttribute('data-wand'); if (s) { var pi = new Image(); pi.src = s; } });
      wandWrap.style.transition = 'transform .7s var(--ease)';
      if (arc) arc.setAttribute('d', arcPath(0));
      var i = 0, timer = null;
      if ('IntersectionObserver' in window) {
        var dio = new IntersectionObserver(function (e) {
          e.forEach(function (en) {
            if (en.isIntersecting && !timer) { var speed = parseInt(dial.getAttribute('data-speed') || '2000', 10); timer = setInterval(function () { i = (i + 1) % list.length; select(list[i]); }, speed); }
            else if (!en.isIntersecting && timer) { clearInterval(timer); timer = null; }
          });
        }, { threshold: 0.4 });
        dio.observe(dial);
      }
      opts.addEventListener('click', function () { if (timer) { clearInterval(timer); timer = null; } });
    });
  }

  /* ---------- before & after slider ---------- */
  function initBeforeAfter() {
    document.querySelectorAll('[data-ba]').forEach(function (ba) {
      var line = ba.querySelector('[data-ba-line]');
      var handle = ba.querySelector('[data-ba-handle]');
      if (!line || !handle) return;

      var pos = 70;
      var dragging = false;

      function setPos(pct) {
        pos = Math.min(95, Math.max(5, pct));
        ba.style.setProperty('--ba-pos', pos + '%');
      }

      function getPos(clientX) {
        var r = ba.getBoundingClientRect();
        return ((clientX - r.left) / r.width) * 100;
      }

      // Mouse
      line.addEventListener('mousedown', function (e) {
        dragging = true;
        handle.classList.add('bp-dragging');
        handle.classList.remove('bp-glow');
        e.preventDefault();
      });
      document.addEventListener('mousemove', function (e) {
        if (dragging) setPos(getPos(e.clientX));
      });
      document.addEventListener('mouseup', function () {
        if (!dragging) return;
        dragging = false;
        handle.classList.remove('bp-dragging');
        handle.classList.add('bp-glow');
      });

      // Touch — touch-action:none on .ba__line prevents accidental scroll
      line.addEventListener('touchstart', function () {
        dragging = true;
        handle.classList.add('bp-dragging');
        handle.classList.remove('bp-glow');
      }, { passive: true });
      document.addEventListener('touchmove', function (e) {
        if (dragging) setPos(getPos(e.touches[0].clientX));
      }, { passive: true });
      document.addEventListener('touchend', function () {
        if (!dragging) return;
        dragging = false;
        handle.classList.remove('bp-dragging');
        handle.classList.add('bp-glow');
      });

      // Entrance nudge: smoothly animates left/right to teach dragging
      function animTo(target, doneCallback) {
        var from = pos;
        var startT = null;
        var STEP_MS = 310;
        function tick(ts) {
          if (!startT) startT = ts;
          var p = Math.min(1, (ts - startT) / STEP_MS);
          var ease = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
          setPos(from + (target - from) * ease);
          if (p < 1) { requestAnimationFrame(tick); } else { if (doneCallback) doneCallback(); }
        }
        requestAnimationFrame(tick);
      }

      function runNudge() {
        var steps = [30, 80, 70];
        var idx = 0;
        function next() {
          if (idx >= steps.length) { handle.classList.add('bp-glow'); return; }
          animTo(steps[idx++], next);
        }
        setTimeout(next, 700);
      }

      if ('IntersectionObserver' in window) {
        var nudged = false;
        var bio = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting && !nudged) {
              nudged = true;
              runNudge();
              bio.disconnect();
            }
          });
        }, { threshold: 0.5 });
        bio.observe(ba);
      } else {
        handle.classList.add('bp-glow');
      }
    });
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = document.getElementById('toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('show'); }, 2400);
  }
  window.bpToast = toast;

  /* ---------- AJAX cart drawer ---------- */
  var money = window.Shopify && Shopify.money_format ? Shopify.money_format : '${{amount}}';
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    return money.replace(/\{\{\s*amount\s*\}\}/, value);
  }
  function openCart() { document.getElementById('cart-drawer').classList.add('open'); document.getElementById('cart-scrim').classList.add('open'); }
  function closeCart() { document.getElementById('cart-drawer').classList.remove('open'); document.getElementById('cart-scrim').classList.remove('open'); }
  window.bpOpenCart = openCart; window.bpCloseCart = closeCart;

  function renderCart(cart) {
    var items = document.getElementById('cart-items');
    var countEl = document.getElementById('cart-count');
    var subEl = document.getElementById('cart-subtotal');
    if (countEl) { countEl.textContent = cart.item_count; countEl.style.display = cart.item_count ? 'inline-flex' : 'none'; }
    if (subEl) subEl.textContent = formatMoney(cart.total_price);
    if (!items) return;
    if (!cart.items.length) { items.innerHTML = '<div class="cart__empty">Your bag is empty.</div>'; }
    else {
      items.innerHTML = cart.items.map(function (it) {
        var img = it.image ? it.image.replace(/(\.[^.]+)(\?|$)/, '_120x$1$2') : '';
        return '<div class="citem" data-key="' + it.key + '">' +
          '<img class="citem__img" src="' + img + '" alt="">' +
          '<div><h5>' + it.product_title + '</h5><div class="cp">' + formatMoney(it.final_price) + '</div>' +
          '<div class="citem__q"><button data-cart-step="-1">−</button><span>' + it.quantity + '</span><button data-cart-step="1">+</button></div>' +
          '<button class="citem__rm" data-cart-remove>Remove</button></div>' +
          '<div class="cp">' + formatMoney(it.final_line_price) + '</div></div>';
      }).join('');
    }
    // gentle upsell handled by data attributes rendered server-side
    var up = document.getElementById('cart-upsell');
    if (up) {
      var hasUpsellTrigger = cart.items.some(function (i) { return (i.handle || '') === up.getAttribute('data-trigger-handle'); });
      var hasUpsellProduct = cart.items.some(function (i) { return (i.handle || '') === up.getAttribute('data-upsell-handle'); });
      up.classList.toggle('show', hasUpsellTrigger && !hasUpsellProduct);
    }
    bindCartRows();
  }

  function fetchCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  function addVariant(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function (r) { return r.json(); });
  }
  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function bindCartRows() {
    document.querySelectorAll('#cart-items .citem').forEach(function (row) {
      var key = row.getAttribute('data-key');
      var qty = parseInt(row.querySelector('.citem__q span').textContent, 10);
      row.querySelectorAll('[data-cart-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var d = parseInt(b.getAttribute('data-cart-step'), 10);
          changeLine(key, Math.max(0, qty + d)).then(renderCart);
        });
      });
      var rm = row.querySelector('[data-cart-remove]');
      rm && rm.addEventListener('click', function () { changeLine(key, 0).then(renderCart); });
    });
  }

  function initCart() {
    var scrim = document.getElementById('cart-scrim');
    scrim && scrim.addEventListener('click', closeCart);
    document.querySelectorAll('[data-cart-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
    });
    document.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });

    // Intercept product add-to-cart forms for a drawer experience (still works without JS)
    document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return; // graceful fallback to normal POST
        e.preventDefault();
        var id = form.querySelector('[name="id"]').value;
        var q = form.querySelector('[name="quantity"]');
        addVariant(id, q ? parseInt(q.value, 10) : 1).then(function () {
          return fetchCart();
        }).then(function (cart) { renderCart(cart); openCart(); toast('Added to bag'); })
          .catch(function () { form.submit(); });
      });
    });

    // upsell add button inside drawer
    var upBtn = document.querySelector('[data-cart-upsell-add]');
    upBtn && upBtn.addEventListener('click', function () {
      var vid = upBtn.getAttribute('data-variant-id');
      addVariant(vid, 1).then(fetchCart).then(renderCart);
    });

    fetchCart().then(renderCart);
  }

  /* ---------- init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initAccordions();
    initGalleries();
    initBeforeAfter();
    initQty();
    initShare();
    initMobileNav();
    initDial();
    initCart();
  });
})();
